import { render } from "./SidePanelInfo.vue?vue&type=template&id=e2099518&scoped=true"
import script from "./SidePanelInfo.vue?vue&type=script&lang=js"
export * from "./SidePanelInfo.vue?vue&type=script&lang=js"

import "./SidePanelInfo.vue?vue&type=style&index=0&id=e2099518&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2099518"]])

export default __exports__